import { FC } from "react";
import { PassCheckItem } from "./PassCheckItem";
import { Stack, Typography } from "@mui/material";

export const PassCheckBlock: FC<{
  isMobile: boolean;
  isNotEqual: boolean | null;
  isMinLength: boolean | null;
  isHaveUpper: boolean | null;
  isHaveLower: boolean | null;
  isHaveSpecial: boolean | null;
  isHaveNumber: boolean | null;
}> = ({
  isMobile,
  isNotEqual,
  isMinLength,
  isHaveLower,
  isHaveNumber,
  isHaveSpecial,
  isHaveUpper,
}) => {
  if (isMobile) {
    return (
      <Stack
        sx={{
          marginBottom: "20px",
          fontSize: "16px",
          color: "#1C1F21B1",
        }}
        direction='column'
      >
        <span>The password should </span>
        <PassCheckItem text='not be equal to email' condition={isNotEqual} />
        <span>and have at least </span>
        <PassCheckItem text='6 characters' condition={isMinLength} />
        <PassCheckItem
          text='one uppercase latin letter'
          condition={isHaveUpper}
        />
        <PassCheckItem
          text='one lowercase latin letter'
          condition={isHaveLower}
        />
        <PassCheckItem text='one special character' condition={isHaveSpecial} />
        <PassCheckItem text='one number' condition={isHaveNumber} />
      </Stack>
    );
  } else {
    return (
      <Typography
        variant='h6'
        sx={{
          marginBottom: "20px",
          fontSize: "16px",
          color: "#1C1F21B1",
        }}
      >
        <span>The password should </span>
        <PassCheckItem text='not be equal to email ' condition={isNotEqual} />
        <span>and have at least </span>
        <PassCheckItem text='6 characters' condition={isMinLength} />,
        <PassCheckItem
          text=' one uppercase latin letter'
          condition={isHaveUpper}
        />
        ,
        <PassCheckItem
          text=' one lowercase latin letter'
          condition={isHaveLower}
        />
        ,
        <PassCheckItem
          text=' one special character '
          condition={isHaveSpecial}
        />
        and
        <PassCheckItem text=' one number' condition={isHaveNumber} />
      </Typography>
    );
  }
};
